module.exports = __webpack_public_path__ + "static/media/faq-dias.cf28a608.png";